class BackgroundSplider extends Carousel {
  constructor() {
    super();
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        threshold: [0.75, 1.0], 
      }
    );
    this.observeSlidesWithVideos();

    this.carousel.on('updated', () => {
      this.observeSlidesWithVideos();
    });
  }

  observeSlidesWithVideos() {
    const slides = this.carousel.Components.Elements.list.children;
    Array.from(slides).forEach((slide) => {
      const video = slide.querySelector('video');
      if (video) {
        this.observer.observe(slide); 
      }
    });
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      const slide = entry.target;
      const video = slide.querySelector('video');
      if (video) {
        if (entry.intersectionRatio >= 0.75) {
          video.play();
        } else {
          video.pause();
        }
      }
    });
  }
}

customElements.define("background-splider", BackgroundSplider);